import { render, staticRenderFns } from "./PopularPlate.vue?vue&type=template&id=65f5f0ae"
import script from "./PopularPlate.vue?vue&type=script&lang=js"
export * from "./PopularPlate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports